export enum jitsiConferenceStatus {
    NotStarted = 1,
    Ongoing = 2,
    Ended = 3
}

export enum CallNotificationResponseTypeEnum {
    Accepted = 1,
    Declined = 2
}
